import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const clinicalNoteService = {
  listAll: async () => {
    const response = await api.get('/clinical-notes');
    return response.data;
  },
  listByPatient: async (patientId) => {
    const response = await api.get(`/clinical-notes/patient/${patientId}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/clinical-notes', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/clinical-notes/${id}`, data);
    return response.data;
  },
  listUnsigned: async () => {
    const response = await api.get('/clinical-notes/queue/unsigned');
    return response.data;
  },
  sign: async (id, body = {}) => {
    const response = await api.post(`/clinical-notes/${id}/sign`, body);
    return response.data;
  },
  createBilling: async (id, body = {}) => {
    const response = await api.post(`/clinical-notes/${id}/create-billing`, body);
    return response.data;
  },
};

export default clinicalNoteService;
